module.exports = __webpack_public_path__ + "static/yuan_ti_malison_type_1-9ce306aab45e24932866ba2bd51d2d1e.jpeg";